import gql from 'graphql-tag'
import Fragment from './fragment'

export const mutation = gql`
  ${Fragment}
  mutation updateAppraisalExternalOffer($id: Int!,$fields: purchase_appraisal_external_offer_set_input!) {
    record: update_purchase_appraisal_external_offer_by_pk(pk_columns: {id: $id},_set: $fields) {
      ...AppraisalExternalOfferForm
    }
  }
`

export default mutation
